import { useTranslation } from "react-i18next";
import { DataGrid } from "@mui/x-data-grid";
import { ptBR, enUS as en, esES as es } from "@mui/x-data-grid/locales";
import { Localization } from "@mui/x-data-grid/internals";

const languages: { [language: string]: Localization } = {
  ptbr: ptBR,
  en,
  es,
};

const DataGridWrapper: typeof DataGrid = (props) => {
  const { i18n } = useTranslation();
  const locale = languages[i18n.language] ?? en;

  return (
    <DataGrid
      {...props}
      localeText={locale.components.MuiDataGrid.defaultProps.localeText}
      sx={{
        cursor: "pointer",
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: "700 !important",
        },
      }}
      autoHeight
    />
  );
};

export default DataGridWrapper;
